import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import { Grid, Form, Container } from 'semantic-ui-react';

import { SelectField, InputField } from 'Common/SemanticWrapper';
import { FieldEnum } from 'Common/FieldEnum';
import DayDropDown from 'Common/Components/DayDropDown/DayDropDown';
import { SelectFieldWithAddRemoveContainer } from 'Components/selectFieldWithAddRemove/container';
import { TitledCard } from 'Components';

class StaplesForm extends Component {
  componentDidMount() {
    //Hack below
    //if previously got a redux form error, it would never reset
    this.props.setIsValid(true);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.valid !== this.props.valid) {
      this.props.setIsValid(this.props.valid);
    }
  }
  render() {
    const { handleWarehouseKitchenSubmit, getStorageLocation } = this.props;
    return (
      <Container>
        <Form onSubmit={handleWarehouseKitchenSubmit}>
          <div className="warehouseKitchenWidget">
            <Field
              name={FieldEnum.WareHousesAndKitchens}
              component={SelectFieldWithAddRemoveContainer}
              {...{
                dataSource: this.props.getSourceForWarehouseAndKitchen(),
              }}
            />
          </div>
          <TitledCard title={'Staples'}>
            <Grid className="tight">
              <Grid.Row columns={3}>
                <Grid.Column>
                  <DayDropDown name={FieldEnum.StapleDayOfWeekId} />
                </Grid.Column>
                <Grid.Column>
                  <Field
                    name={FieldEnum.StapleStorageLocationId}
                    component={SelectField}
                    label={'Storage Location'}
                    options={getStorageLocation()}
                  />
                </Grid.Column>
                <Grid.Column>
                  <Field
                    name={FieldEnum.StapleRoute}
                    component={InputField}
                    type="text"
                    label={'Route'}
                    maxLength={15}
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </TitledCard>
        </Form>
      </Container>
    );
  }
}
const validate = (values, props) => {
  const errors = {};
  return errors;
};
export default reduxForm({
  validate,
  enableReinitialize: true,
  form: 'StaplesSetupForm',
})(StaplesForm);



// WEBPACK FOOTER //
// ./src/pages/sitesetup/components/StaplesForm.js